export const getExperimentArm = (experiments, experimentName) => {
    return (experiments === null || experiments === void 0 ? void 0 : experiments[experimentName]) || 'C';
};
/** Frontend key for the multi-ASIN landing page weblab. */
const MALP_WEBLAB = 'WEBLAB_PAINTER_MULTI_ASIN_LANDING_PAGE';
/**
 * Whether the multi-ASIN landing page should render for this request: only on
 * its route, and only when the weblab arm resolves to T1. Pure: no React, no
 * browser state.
 *
 * Fails closed — the weblab (owned by this team) has two arms, C and T1, so any
 * non-T1 outcome (control, an unresolved appInit, or a missing key before
 * server-side registration lands) is simply "not in treatment, don't render".
 * Marketplace gating is left to the weblab allocation.
 *
 * @param isMALP - Whether the current route is the multi-ASIN landing page
 * @param experiments - The `experiments` map from `useAppInit`'s data (undefined until it resolves)
 */
export const isMultiAsinLandingPageEnabled = (isMALP, experiments) => isMALP && getExperimentArm(experiments, MALP_WEBLAB) === 'T1';
/** Frontend key for the 1-Click Checkout weblab. */
const ONE_CLICK_CHECKOUT_WEBLAB = 'WEBLAB_PAINTER_PDP_ONE_CLICK_CHECKOUT';
/**
 * Whether Buy now on the PDP should open the 1-Click Checkout sheet instead of
 * navigating to POP: only for linked customers in T1. Pure: no React, no
 * browser state.
 *
 * Fails closed — an unresolved appInit or a missing key keeps today's flow.
 * Marketplace gating is left to the weblab allocation (US and CA only).
 *
 * @param linked - `appInit` linked status
 * @param experiments - The `experiments` map from `useAppInit`'s data (undefined until it resolves)
 */
export const isOneClickCheckoutEnabled = (linked, experiments) => !!linked && getExperimentArm(experiments, ONE_CLICK_CHECKOUT_WEBLAB) === 'T1';
